let fileUploadRevealAttached = false;

/**
 * Progressive File 2 / File 3 reveal for File Upload forms.
 *
 * Gravity Forms 3.x theme scripts re-render file fields after document.ready,
 * which drops direct .change() handlers and any inline show/hide styles.
 * Bind on document and re-query the live inputs whenever a file changes
 * or gform_post_render fires.
 */
export function attachFileUploadReveal() {
  if (fileUploadRevealAttached) {
    return;
  }
  fileUploadRevealAttached = true;

  const fileInputSelector = [
    'form.file-upload-form input[type="file"][id$="_4"]',
    'form.file-upload-form input[type="file"][id$="_12"]',
    'form.file-upload-form input[type="file"][id$="_11"]',
  ].join(', ');

  const showHideUploads = function($form) {
    if (!$form || !$form.length) {
      $form = $('form.file-upload-form');
    }

    $form.each(function() {
      const $f = $(this);
      const file_1 = $f.find('input[type="file"][id$="_4"]').first();
      const file_2 = $f.find('input[type="file"][id$="_12"]').first();
      const file_3 = $f.find('input[type="file"][id$="_11"]').first();

      if (!file_1.length || !file_2.length || !file_3.length) {
        return;
      }

      if (file_1.val()) {
        file_2.closest('.gfield').show();
      } else {
        file_2.closest('.gfield').hide();
      }

      if (file_1.val() && file_2.val()) {
        file_3.closest('.gfield').show();
      } else {
        file_3.closest('.gfield').hide();
      }
    });
  };

  $(document).on('change.fileUploadReveal', fileInputSelector, function() {
    showHideUploads($(this).closest('form.file-upload-form'));
  });

  $(document).on('gform_post_render.fileUploadReveal', function(event, formId) {
    const $form = $('#gform_' + formId);
    if ($form.hasClass('file-upload-form')) {
      showHideUploads($form);
    }
  });

  $(function() {
    showHideUploads();
  });
}

export default {
  init() {
    attachFileUploadReveal();
  },
};
